/**
 * EntoRid central contact constants.
 * Use these everywhere — never hard-code phone, email or WA URLs in components.
 *
 * Call number: +91 78199 88010 (Sales / Support line)
 * WhatsApp number: +91 94101 10910 (Chat support)
 * Email: info.entorid@gmail.com
 */

export const CALL_NUMBER = '7819988010';
export const CALL_DISPLAY = '+91 78199 88010';
export const CALL_TEL = `tel:+91${CALL_NUMBER}`;

export const WA_NUMBER = '9410110910';
export const WA_DISPLAY = '+91 94101 10910';

/**
 * Build a WhatsApp click-to-chat URL.
 * We use https://api.whatsapp.com/send?phone=... which is the most reliable cross-platform format —
 * it correctly fires the Android/iOS intent that opens the WhatsApp app and gracefully falls back to
 * WhatsApp Web on desktop. Avoid `wa.me` shortlinks: some Android Chrome/UC builds fail to deep-link.
 */
export const buildWaUrl = (text) => {
  const base = `https://api.whatsapp.com/send?phone=91${WA_NUMBER}`;
  return text ? `${base}&text=${encodeURIComponent(text)}` : base;
};

export const WA_URL = buildWaUrl('Hello EntoRid, I want to book a pest control service.');

export const SUPPORT_EMAIL = 'info.entorid@gmail.com';
export const MAILTO = `mailto:${SUPPORT_EMAIL}`;
